import type { ReactNode } from "react";

interface PlaceholderProps {
  /** What the real text in this section must cover. */
  children: ReactNode;
}

/**
 * Marks a section whose legal text has not been supplied yet. Renders a
 * visible notice (so nobody mistakes a draft for the real policy) and
 * lists what the final text must cover. Replace each <Placeholder> with
 * the approved wording — never invent binding terms here.
 *
 * `grep -rn "<Placeholder" apps/shell/src/pages/legal` finds what's left.
 */
export function Placeholder({ children }: PlaceholderProps) {
  return (
    <div className="legal-placeholder" role="note" aria-label="Placeholder — legal text needed">
      <p className="legal-placeholder__label">Placeholder — legal text needed</p>
      <div className="legal-placeholder__body">{children}</div>
    </div>
  );
}
